import { PhoneNumberUtil } from 'google-libphonenumber';
import type { ValidateResult } from 'react-hook-form';
import * as validator from 'validator';

const phoneUtil = PhoneNumberUtil.getInstance();

export function validatePhoneNumber(phone?: string): ValidateResult {
  const raw = phone?.trim() ?? '';

  if (!raw) return 'Work Telephone is required.';

  if (!raw.startsWith('+')) {
    return 'Phone Number must include country code. Example: +1 (778) 238-8728';
  }

  const parsed = phoneUtil.parseAndKeepRawInput(raw);

  return phoneUtil.isValidNumber(parsed)
    ? true
    : 'Enter a valid phone number with country code. Example: +1 (778) 238-8728';
}

export function validateEmail(email?: string): ValidateResult {
  if (!email?.trim()) return 'Email is required';
  return validator.isEmail(email.trim()) ? true : 'Invalid email';
}

export function validateInstagramUrl(url?: string): ValidateResult {
  const raw = url?.trim() ?? '';
  if (!raw) return true;

  // Require instagram host + /username (and NOT /p/... or /reel/... etc)
  const profileRegex = /^https?:\/\/(?:www\.)?instagram\.com\/(?!p\/|reel\/|tv\/|stories\/|explore\/)([a-zA-Z0-9._]{1,30})\/?$/;

  return profileRegex.test(raw)
    ? true
    : 'Instagram link must be a profile URL like https://www.instagram.com/sterlingsound';
}
